import { isEqual } from '../../services/lodash'
import { tagsParser, TagsParserResponse } from '../../services/tagsParser'

const countNodes = (selectors: string[]) =>
    selectors.map(selector => ({
        selector,
        count: document.querySelectorAll(selector).length,
    }))

// If location or DOM changes, send new tagsParser response to React
export const locationObserver = async (iframe, disableAutoTags = false) => {
    let prevLocation: string | null = null
    let prevNodeCount: { selector: string; count: number }[] = []
    // SDK doesn't have ability to fetch app in parent
    let prevFilters: TagsParserResponse =
        SDK_MODE || disableAutoTags
            ? {
                  domain: '',
                  app: '',
                  appName: '',
                  tags: [],
                  querySelectors: [],
              }
            : await tagsParser() // Re-run only if location or nodeCount changed

    window.setInterval(async () => {
        const newLocation = document.location.href
        const newNodeCount = prevFilters.querySelectors.length
            ? countNodes(prevFilters.querySelectors)
            : []

        const shouldUpdateLocation = prevLocation !== newLocation
        const shouldUpdateNodeCount = prevFilters.querySelectors.length
            ? !isEqual(prevNodeCount, newNodeCount)
            : false

        // For location observer hook
        if (shouldUpdateLocation) {
            iframe.contentWindow?.postMessage(
                {
                    type: 'URL_CHANGED',
                    location: JSON.stringify(window.location),
                },
                iframe.src
            )
        }

        if (EXT_MODE && !disableAutoTags) {
            // For tags parser observer hook
            if (shouldUpdateLocation || shouldUpdateNodeCount) {
                const newFilters = await tagsParser()

                iframe.contentWindow?.postMessage(
                    {
                        type: 'DEFAULT_TAGS_CHANGED',
                        data: JSON.stringify(newFilters),
                    },
                    iframe.src
                )

                prevFilters = newFilters
            }
        }

        prevLocation = newLocation
        prevNodeCount = newNodeCount
    }, 1000)
}
